module.exports = __webpack_public_path__ + "img/options-icon.adffc3a7.svg";